export const GET_COMPANY_STRUCTURE_REQUEST = "GET_COMPANY_STRUCTURE_REQUEST";
export const GET_COMPANY_STRUCTURE_REQUEST_SUCCEEDED = "GET_COMPANY_STRUCTURE_REQUEST_SUCCEEDED";
export const GET_COMPANY_STRUCTURE_REQUEST_FAILED = "GET_COMPANY_STRUCTURE_REQUEST_FAILED";
